import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";

import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";

import { CoreModule } from "@tylertech/core-module";
import { AggregatesModule } from "@tylertech/aggregates-module";
import { AccountsPayableModule } from "@tylertech/accounts-payable-module";

import { PoReceiptDetailComponent } from "./components/packetDetail/poReceiptDetail.component";
import { GlJournalEntryDetailComponent } from "./components/packetDetail/glJournalEntryDetail.component";
import { ApPaymentDetailComponent } from "./components/packetDetail/apPaymentDetail.component";
import { ApPayableDetailComponent } from "./components/packetDetail/apPayableDetail.component";
import { PacketDetailDialogComponent } from "./components/packetDetail/packetDetailDialog.component";

import { PacketDialogsService } from "./services/packetDialogService";
import { PacketService } from "./services/packet.service";
import { ProcessLookupService } from "./services/processLookupService.g";

import { PacketActionHandler } from "./aggregateActionHandler/packetActionHandler";

const angularModules = [
    CommonModule,
    FlexModule,
    FlexLayoutModule,
];

const angularMaterialModules = [
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatTableModule,
    MatTooltipModule
];

const lgdModules = [
    CoreModule,
    AggregatesModule
        .withActionHandlers(PacketActionHandler),
    AccountsPayableModule
];

const declarations = [
    PoReceiptDetailComponent,
    GlJournalEntryDetailComponent,
    ApPaymentDetailComponent,
    ApPayableDetailComponent,
    PacketDetailDialogComponent,
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules
    ],
    declarations: declarations,
    exports: declarations,
    providers: [
        PacketDialogsService,
        PacketService,
        ProcessLookupService,
        PacketActionHandler
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PacketsModule { }
